import React, { useState } from 'react';

const Testimonials = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  
  const testimonials = [
    {
      name: 'Ayesha Khan',
      role: 'Mother of 8-month-old',
      content: 'Tifl has transformed how I track my baby\'s development. The milestone tracking gives me peace of mind, and the daily goals keep us engaged. It\'s like having a pediatrician in my pocket!',
      rating: 5,
      image: '👩‍🦰',
      milestone: 'First words tracked'
    },
    {
      name: 'Ahmed Hassan',
      role: 'Father of twins',
      content: 'Managing twins was overwhelming until we found Tifl. The personalized goals for each child and the community support have been invaluable. We celebrate every small victory now!',
      rating: 5,
      image: '👨',
      milestone: 'Sleep patterns improved'
    },
    {
      name: 'Fatima Ali',
      role: 'First-time mom',
      content: 'As a first-time parent, I was constantly worried. Tifl\'s expert guidance and progress tracking showed me my baby is thriving. The interface is so intuitive and calming.',
      rating: 5,
      image: '👩',
      milestone: 'Rolled over at 4 months'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-pink-50 to-white" id="testimonials">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center bg-white rounded-full px-4 py-2 mb-4 shadow-sm">
            <span className="text-pink-600 font-semibold text-sm uppercase tracking-wider">Success Stories</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#0C1D40] mb-6">
            Parents Love Tifl
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Join thousands of parents who trust Tifl to guide them through their parenting journey
          </p>
        </div>

        {/* Testimonials Carousel */}
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12">
            <div className="flex items-start gap-4 mb-6">
              <div className="w-16 h-16 bg-pink-100 rounded-full flex items-center justify-center text-3xl flex-shrink-0">
                {testimonials[activeIndex].image}
              </div>
              <div className="flex-1">
                <h3 className="font-bold text-[#0C1D40] text-xl">{testimonials[activeIndex].name}</h3>
                <p className="text-gray-500">{testimonials[activeIndex].role}</p>
                <div className="flex items-center gap-1 mt-2">
                  {[...Array(testimonials[activeIndex].rating)].map((_, i) => (
                    <svg key={i} className="w-5 h-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
                    </svg>
                  ))}
                </div>
              </div>
            </div>
            
            <blockquote className="text-lg text-gray-600 mb-6 leading-relaxed italic">
              "{testimonials[activeIndex].content}"
            </blockquote>
            
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2 bg-green-50 px-4 py-2 rounded-full">
                <svg className="w-5 h-5 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"/>
                </svg>
                <span className="text-sm font-medium text-green-700">{testimonials[activeIndex].milestone}</span>
              </div>
              
              {/* Pagination dots */}
              <div className="flex gap-2">
                {testimonials.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setActiveIndex(index)}
                    className={`w-2 h-2 rounded-full transition-all ${
                      activeIndex === index ? 'w-8 bg-[#0C1D40]' : 'bg-gray-300'
                    }`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;